<p>Logging out. Please wait...</p>
<a [routerLink]="['/auth/login']">Click here</a> if you are not automatically redirected.
